module.exports = __webpack_public_path__ + "static/media/icons8-trash.14291ac9.svg";